import styled from 'styled-components';
import { DEVICES_TYPE } from '../../../../common/constants';
import COLORS from '../../../../common/colors';

const { MOBILE, TABLET } = DEVICES_TYPE;

export const StyledCloseButton = styled.div`
  ${({ isDirectionRtl }) => isDirectionRtl ? 'left:10px; right:unset;' : 'left:initial; right:10px;'}
  position: absolute;
  outline: none;
  width: 27px;
  height: 27px;
  font-size: 20px;
  text-align: center;
  top: 10px;
  border-radius: 100%;
  background-color: #ccc;
  color: #000;
  z-index: 1;
  &:focus{
    outline: ${COLORS.BLUE_WCAG_BORDER} solid 2px;
    outline-offset: 2px;
  }
`;

export const StyledInvitationContent = styled.div`
  ${({ deviceType, isDirectionRtl }) =>
    deviceType === MOBILE
      ? `
        color: black;
        padding-left: ${isDirectionRtl ? '47px' : '15px'};
        padding-right:${isDirectionRtl ? '15px' : '47px'};
        padding-top: 13px;
        margin-bottom: 14px;
        padding-bottom: 0px;
        `
      : `
        padding-top: 15px;
        padding-bottom: 25px;
        max-width: 435px;
        padding-right: ${isDirectionRtl ? '0px' : '20px'};
        `}
`;
export const StyledInvitationContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;
  ${({ deviceType }) =>
    deviceType === TABLET
      ? `   
        max-width: 600px;
        margin: auto;
        position: relative;`
      : ``}
`;

export const StyledInvitationTitle = styled.h2`
  font-size: ${({ deviceType }) => (deviceType === MOBILE ? '1.1875rem' : '1.5625rem')};
  text-overflow: ellipsis;
  display: block;
  margin-bottom: ${({ deviceType }) => deviceType === MOBILE ? '10px' : '8px'};
  color: black;
  font-family: 'Open Sans';
  font-weight: normal;
  margin-top: 0px;
`;

export const StyledInvitationBody = styled.div`
  font-size: ${({ deviceType }) => (deviceType === MOBILE ? '0.875rem' : '1rem')};
  font-weight: normal;
`;

export const StyledProvideButton = styled.div`
  margin: 0 15px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: ${({ deviceType }) => (deviceType === MOBILE ? '8px' : '25px')};
  flex-flow: row nowrap;
`;

export const Button = styled.button`
  color: ${({ color }) => color};
  background-color: ${({ backgroundColor }) => backgroundColor};
  border: none;
  outline: none;
  word-wrap: break-word;
  white-space: normal;
  text-align: center;
  overflow: hidden;
  min-height: fit-content;
  font-size: 0.875rem;
  padding: 6px 15px;
  border-radius: 5px;
  max-width: 180px;
  &:focus{
    outline: ${COLORS.BLUE_WCAG_BORDER} solid 2px;
    outline-offset: 2px;
  }
`;
